import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-capacity-overview",
  "use": "icon-capacity-overview-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-capacity-overview\">\n<g id=\"icon-capacity-overview_Group 178074\">\n<path id=\"icon-capacity-overview_Vector 1091\" d=\"M5 34.9998V24.7998H15.5C19.1 30.2398 23 27.0665 24.5 24.7998H35V34.9998H5Z\" stroke=\"#789CB9\" stroke-width=\"2\" />\n<path id=\"icon-capacity-overview_Vector 1089\" d=\"M5 12.8811L9 5H31L35 12.8811V21.2H5V12.8811Z\" stroke=\"#789CB9\" stroke-width=\"2\" />\n<path id=\"icon-capacity-overview_Vector 1090\" d=\"M5 14H15.5C16.6667 15.8111 20.1 18.3466 24.5 14H35\" stroke=\"#789CB9\" stroke-width=\"2\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/capacity-overview.svg
// module id = XgaH
// module chunks = 103